import { forwardRef } from 'react';
import { cn } from '../../lib/cn';
import { Tooltip } from './Tooltip';

// Przycisk ikonowy z podpowiedzią.
//
// Zastępuje ~15 wystąpień tego samego wzorca w tabelach, gdzie każdy przycisk
// akcji miał ręcznie wpisane 12 linii markupu dymka. Etykieta trafia zarówno do
// podpowiedzi, jak i do aria-label, więc akcja jest opisana także dla czytników
// ekranu — wcześniej były to przyciski bez żadnej dostępnej nazwy.

const TONES = {
  default: 'text-muted hover:bg-elevated hover:text-content',
  accent: 'text-accent hover:bg-accent-soft',
  success: 'text-success hover:bg-success-soft',
  warn: 'text-warn hover:bg-warn-soft',
  danger: 'text-danger hover:bg-danger-soft',
  info: 'text-info hover:bg-info-soft',
};

const SIZES = {
  sm: 'h-7 w-7',
  md: 'h-8 w-8',
};

export const IconButton = forwardRef(function IconButton(
  { icon: Icon, label, tone = 'default', size = 'md', className, tooltipSide = 'top', ...props },
  ref
) {
  const button = (
    <button
      ref={ref}
      type="button"
      aria-label={label}
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-md transition-colors',
        'disabled:pointer-events-none disabled:opacity-40',
        TONES[tone],
        SIZES[size],
        className
      )}
      {...props}
    >
      <Icon size={size === 'sm' ? 15 : 17} />
    </button>
  );

  if (!label) return button;

  return (
    <Tooltip label={label} side={tooltipSide}>
      {button}
    </Tooltip>
  );
});

export default IconButton;
